module.exports = __webpack_public_path__ + "static/img/pc-web04@t.ef50002.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lg-archive/pc-web04@t.png
// module id = bECe
// module chunks = 0